/* eslint-disable @typescript-eslint/naming-convention */
import { createContext } from 'react';
import { Advisors } from './advisor';

/**
 * Context for the advisor dataset.
 */
export const AdvisorContext = createContext<Advisors>({});
